<template>
<v-layout row wrap>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <!--
      <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
      -->
      <v-btn color="pink" dark small fixed top right fab style="top:44px" v-on="on">
        <v-icon>add</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                :items="['daejeon', 'test']"
                v-model="editedItem.group"
                label="group"
                single-line
                />
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="editedItem.managementNumber" label="충전기 관리번호"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="editedItem.status" label="충전기 상태"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="editedItem.model" label="모델"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="editedItem.manufacturer" label="제조사"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="$_close">취소</v-btn>
        <v-btn color="blue darken-1" flat @click="$_save">저장</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-flex xs12>
    <v-card>
      <!--
      <v-card-title>
        Nutrition
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      -->
      <v-data-table
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :headers="headers"
        :items="datas"
        :search="search"
        :loading="loading">
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <td>{{ props.item.managementNumber }}</td>
          <td>{{ props.item.group }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          <td class="text-xs-left">{{ props.item.model }}</td>
          <td class="text-xs-left">{{ props.item.manufacturer }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              small
              class="mr-2"
              @click="$_editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              small
              @click="$_deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
  <!--
  <v-btn fixed dark fab bottom right color="pink"
    @click="$router.push({name:'ChargerAdd'})">
    <v-icon>add</v-icon>
  </v-btn>
  -->
</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'

export default {
  name: 'HelloWorld',
  data () {
    return {
      search: '',
      headers: [{text: '관리번호', values: 'managementNumber', sortable: false},
        {text: 'group', values: 'group', sortable: false},
        {text: '상태', values: 'status', sortable: false},
        {text: '모델', values: 'model', sortable: false},
        {text: '제조사', values: 'manufacturer', sortable: false},
        {text: '관리', values: 'actions', sortable: false}],
      datas: [],
      rowsPerPageItems: [10, 20, 50, 100, 200],
      pagination: {
        rowsPerPage: 200
      },
      dialog: false,
      editedIndex: -1,
      editedItem: {
        group: this.$store.state.session.group,
        managementNumber: '',
        status: '',
        model: '',
        manufacturer: ''
      },
      defaultItem: {
        group: this.$store.state.session.group,
        managementNumber: '',
        status: '',
        model: '',
        manufacturer: ''
      },
      loading: false
      // items: [{ header: '충전기 목록' }]
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '충전기 신규 등록' : '충전기 정보 수정'
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getChargers()
    },
    dialog (val) {
      val || this.$_close()
    }
  },
  created () {
    this.$emit('title', '충전기 관리')
    this.$_getChargers()
  },
  methods: {
    $_getChargers () {
      this.loading = true

      let query = this.$fs.collection('chargers')
      if (!this.$store.state.session.admin) {
        query = query.where('group', '==', this.$store.state.session.group)
      }

      query
        .orderBy('managementNumber')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id
            this.datas.push(item)
            // console.log(doc.data())
          })

          this.loading = false
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
          }
          this.loading = false
        })
    },
    $_editItem (item) {
      // console.log('edit', item)

      // this.$router.push({name:'ChargerEdit', params:{'id':item.id, 'charger':item}})
      this.editedIndex = this.datas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    $_deleteItem (item) {
      if (item.placeRef) {
        alert('해당 충전기는 충전소에 할당 되어 있습니다.\n충전소-충전기 구성에서 먼저 제거하세요.')
        return
      }

      if (item.plugRef) {
        alert('해당 충전기에 플러그가 할당 되어 있습니다.\n충전기-플러그 구성에서 먼저 제거하세요.')
        return
      }

      const index = this.datas.indexOf(item)
      const name = this.datas[index].managementNumber
      const chargerId = this.datas[index].id
      const inputChargerName = prompt('해당 "' + name + '" 충전기를 정말 삭제하시겠습니까?\n해당 충전기 관리번호를 한번 더 정확하게 입력하세요.')

      if (name === inputChargerName) {
        // TODO loading
        /*
        // 장소 정보에서 해당 충전기 삭제
        // transaction 을 사용하여 reference 가 실제 존재하지 않는 경우를 처리하려고 했으나
        // Every document read in a transaction must also be written. 오류 발생으로 원복함.
        // transaction 은 해당 문서가 있을 경우 read 후 반드시 write 를 해야 함.
        const chargerRef = this.$fs.collection('chargers').doc(chargerId)
        const placeRef = this.datas[index].placeRef
        let job = null

        if (placeRef) {
          job = this.$fs.db().runTransaction(t => {
            return t.get(placeRef)
              .then(doc => {
                // 데이터가 있으니 ref 삭제
                //console.log('transaction', doc, doc.data().chargerRefs)

                try {
                  if (doc.exists) { // Every document read in a transaction must also be written. 오류 발생으로 원복함.
                    let chargerRefs = doc.data().chargerRefs

                    for (var i = 0; i < chargerRefs.length; i++) {
                      if (chargerRefs[i].id === chargerId) {
                        chargerRefs.splice(i, 1)
                        break;
                      }
                    }

                    //console.log('chargers 2', chargers)
                    t.update(placeRef, {'chargerRefs': chargerRefs,
                                updated: firebase.firestore.FieldValue.serverTimestamp()})
                  }

                  t.delete(chargerRef)
                  return Promise.resolve(doc)
                } catch (error) {
                  return Promise.reject(error)
                }
              })
          })
        } else {
          job = chargerRef.delete()
        }
        */

        this.$fs
          .collection('chargers')
          .doc(chargerId)
          .delete()
          .then(() => {
            // 로컬 데이터 업데이트
            this.datas.splice(index, 1)

            this.$emit('snackbar', '삭제되었습니다.')
            this.$_close()
          }).catch(error => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      } else if (inputChargerName) {
        this.$emit('snackbar', '충전기 이름을 다시 확인하세요.')
      }
    },
    $_close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    $_save () {
      if (this.editedIndex > -1) { // 수정
        // TODO loading
        const item = this.datas[this.editedIndex]
        const chargerId = item.id
        const group = item.group

        if (group !== this.editedItem.group) {
          if (item.placeRef) {
            alert('해당 충전기는 충전소에 할당 되어 있습니다.\n그룹 변경을 위해서 충전소-충전기 구성에서 먼저 제거하세요.')
            return
          }

          if (item.plugRef) {
            alert('해당 충전기에 플러그가 할당 되어 있습니다.\n그룹 변경을 위해서 충전기-플러그 구성에서 먼저 제거하세요.')
            return
          }
        }

        this.$fs.collection('chargers')
          .doc(chargerId)
          .set({group: this.editedItem.group,
            managementNumber: this.editedItem.managementNumber,
            status: this.editedItem.status,
            model: this.editedItem.model,
            manufacturer: this.editedItem.manufacturer,
            updated: firebase.firestore.FieldValue.serverTimestamp()}, {merge: true})
          .then(() => {
            // 로컬 데이터 업데이트
            Object.assign(this.datas[this.editedIndex], this.editedItem)

            this.$emit('snackbar', '수정되었습니다.')
            this.$_close()
          }).catch((error) => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      } else { // 신규
        // TODO loading
        // 서버 데이터 업데이트
        this.$fs.collection('chargers')
          .add(Object.assign({created: firebase.firestore.FieldValue.serverTimestamp()}, this.editedItem))
          .then(() => {
            // 로컬 데이터 업데이트
            this.datas.push(this.editedItem)

            this.$emit('snackbar', '등록되었습니다.')
            this.$_close()
          }).catch((error) => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Charger/ChargerList.vue